export default __webpack_public_path__ + "static/SDG_Logo_large-51022d23148ed0a9fa601f6a814aa589.png";